import { isMobileContainer } from './device';

const WEB_APP_VERSION = process.env.REACT_APP_VERSION || '0.1.0';
const MOBILE_SHELL_VERSION = '1.0.0';

export function getFeedbackPageUrl() {
  const hashPath = (window.location.hash || '').replace(/^#/, '').split('?')[0] || '/';
  if (isMobileContainer()) {
    return hashPath;
  }
  return window.location.href;
}

export async function getFeedbackAppVersion() {
  if (!isMobileContainer()) {
    return WEB_APP_VERSION;
  }

  try {
    const { App } = await import('@capacitor/app');
    const info = await App.getInfo();
    const nativeVersion = info?.version?.trim();
    if (nativeVersion) {
      return `${MOBILE_SHELL_VERSION} (native ${nativeVersion}, web ${WEB_APP_VERSION})`;
    }
  } catch {
    // @capacitor/app not available — fall back to shell version
  }

  return `${MOBILE_SHELL_VERSION} (web ${WEB_APP_VERSION})`;
}

export function getFeedbackClient() {
  return isMobileContainer() ? 'mobile' : 'web';
}
